import React, { useEffect, useContext } from "react";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device/DeviceContext';
import TableWithContainer from "utils/Table/TableWithContainer";
import TooltipButton from "utils/TooltipButton/TooltipButton";
import { Grid } from "@material-ui/core";

export default function QuotesDMA(props) {
    const device = useContext(DeviceContext);
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    const style = {
        Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
        Table: {
            FixedColumn: { width: "120px" },
            Header: { minWidth: "120px", lineHeight: "24px", whiteSpace: 'nowrap' },
        }
    };
    const headers = [[props.groupBy, "Total", "Bind %"]];

    switch (props.state)
    {
        case 'MI':
            headers[0].push(
                "Detroit", "Bind %",
                "Flint", "Bind %",
                "Grand Rapids", "Bind %",
                "Lansing", "Bind %",
                "Traverse City", "Bind %",
                "Marquette UP", "Bind %",
                {
                    text: (<>Other<TooltipButton tooltipText={`"Other" includes the following 5 DMAs: Toledo, South Bend-Elkhart, Alpena, Dultuh-Superior, GreenBay-Appleton`} /></>),
                    style: { padding: "0" }
                },
                {
                    text: (<>Bind %<TooltipButton tooltipText={`"Other" includes the following 5 DMAs: Toledo, South Bend-Elkhart, Alpena, Dultuh-Superior, GreenBay-Appleton`} /></>),
                    style: { padding: "0" }
                },
            );
            break;
        case 'NJ':
            headers[0].push(
                "New York-North Jersey", "Bind %",
                "Philadelphia-South Jersey", "Bind %",
            );
            break;
        case 'PA':
            headers[0].push(
                "Philadelphia", "Bind %",
                "Pittsburgh", "Bind %",
                "Harrisburg-Lancaster-Lebanon-York", "Bind %",
                "Wilkes Barre-Scranton-Hazleton", "Bind %",
                "Johnstown-Altoona-State College", "Bind %",
                "Erie", "Bind %",
                {
                    text: (<>Other<TooltipButton tooltipText={`"Other" includes the following 5 DMAs: New York, Washington-Hagerstown, Buffalo, Youngstown, Elmira-Corning`} /></>),
                    style: { padding: "0" }
                },
                {
                    text: (<>Bind %<TooltipButton tooltipText={`"Other" includes the following 5 DMAs: New York, Washington-Hagerstown, Buffalo, Youngstown, Elmira-Corning`} /></>),
                    style: { padding: "0" }
                },
            );
            break;
    }

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", `/DMA/GetQuotes${props.state}`, {
            startDate: props.startDate,
            endDate: props.endDate,
            groupBy: props.groupBy
        });

        if (response) {
            const formattedResponse = (() => {
                switch (props.state) {
                    case 'MI':
                        return response.map((row) => [
                            row.groupBy,
                            integer.format(row.total),
                            percent.format(row.totalBindPercentage / 100),
                            integer.format(row.detroit),
                            percent.format(row.detroitBindPercentage / 100),
                            integer.format(row.flint),
                            percent.format(row.flintBindPercentage / 100),
                            integer.format(row.grandRapids),
                            percent.format(row.grandRapidsBindPercentage / 100),
                            integer.format(row.lansing),
                            percent.format(row.lansingBindPercentage / 100),
                            integer.format(row.traverseCity),
                            percent.format(row.traverseCityBindPercentage / 100),
                            integer.format(row.marquetteUP),
                            percent.format(row.marquetteUPBindPercentage / 100),
                            integer.format(row.other),
                            percent.format(row.otherBindPercentage / 100),
                        ]);
                    case 'NJ':
                        return response.map((row) => [
                            row.groupBy,
                            integer.format(row.total),
                            percent.format(row.totalBindPercentage / 100),
                            integer.format(row.newYorkNorthJersey),
                            percent.format(row.newYorkNorthJerseyBindPercentage / 100),
                            integer.format(row.philadelphiaSouthJersey),
                            percent.format(row.philadelphiaSouthJerseyBindPercentage / 100),
                        ]);
                    case 'PA':
                        return response.map((row) => [
                            row.groupBy,
                            integer.format(row.total),
                            percent.format(row.totalBindPercentage / 100),
                            integer.format(row.philadelphia),
                            percent.format(row.philadelphiaBindPercentage / 100),
                            integer.format(row.pittsburgh),
                            percent.format(row.pittsburghBindPercentage / 100),
                            integer.format(row.harrisburgLancasterLebanonYork),
                            percent.format(row.harrisburgLancasterLebanonYorkBindPercentage / 100),
                            integer.format(row.wilkesBarreScrantonHazleton),
                            percent.format(row.wilkesBarreScrantonHazletonBindPercentage / 100),
                            integer.format(row.johnstownAltoonaStateCollege),
                            percent.format(row.johnstownAltoonaStateCollegeBindPercentage / 100),
                            integer.format(row.erie),
                            percent.format(row.erieBindPercentage / 100),
                            integer.format(row.other),
                            percent.format(row.otherBindPercentage / 100),
                        ]);
                    default:
                        return [];
                }
            })();

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <Grid container>
            <Grid item lg={12} md={12} sm={12} xs={12}>
                <TableWithContainer
                    title="QUOTES"
                    exportName="Quotes"
                    loading={loading}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={style}
                    headers={headers}
                    rows={data.filter(x => x[0] !== "Total")}
                    footers={data.filter(x => x[0] === "Total")}
                />
            </Grid>
        </Grid>
    );
}
